export default "__VITE_ASSET__DLw9Oh0f__"